import { render, staticRenderFns } from "./AppTab.vue?vue&type=template&id=d2f96ffa&"
import script from "./AppTab.vue?vue&type=script&lang=ts&"
export * from "./AppTab.vue?vue&type=script&lang=ts&"
import style0 from "./AppTab.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports